import { Splide } from '/shared.js';



const getDistanceFromRight = () => {
    const remSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const solution_slider_header = document.querySelector('.solution-slider-header');
    return solution_slider_header.getBoundingClientRect().x / remSize;
}



const solutionSlider = new Splide('.solution-slider', {
    pagination: false,

    direction: 'rtl',
    // autoWidth: true,
    type: "loop",
    fixedWidth: "43rem",
    gap: "10rem",
    padding: { left: `${getDistanceFromRight()}rem`, right: `${getDistanceFromRight()}rem` },
    // omit: 'end',
    // trimSpace: true,

    // height: '50rem',
    // speed: 0,
    // updateOnMove: true,


}).mount();

window.addEventListener('resize', () => {
    solutionSlider.options = {
        ...solutionSlider.options,
        padding: { left: `${getDistanceFromRight()}rem`, right: `${getDistanceFromRight()}rem` }
    };
    solutionSlider.refresh();
});






